import { render, staticRenderFns } from "./newMapping.vue?vue&type=template&id=34ad540b&"
import script from "./newMapping.vue?vue&type=script&lang=js&"
export * from "./newMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ad540b')) {
      api.createRecord('34ad540b', component.options)
    } else {
      api.reload('34ad540b', component.options)
    }
    module.hot.accept("./newMapping.vue?vue&type=template&id=34ad540b&", function () {
      api.rerender('34ad540b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/BlockLeave/BlockLeavePolicy/components/newMapping.vue"
export default component.exports